/* eslint-disable @typescript-eslint/no-explicit-any */
import { ColDef, themeAlpine } from "ag-grid-community";
//import CustomDateFilter from "./CustomDateFilter";
import CustomSelectFilter from "./CustomSelectFilter";

export const myAgReactTheme = themeAlpine
    .withParams({
        accentColor: "var(--selected-row)",
        backgroundColor: "var(--bg-lighter)",
        borderColor: "var(--cell-border)",
        borderRadius: 2,
        cellHorizontalPaddingScale: 0.7,
        cellTextColor: "var(--text)",
        checkboxBorderWidth: "2px",
        checkboxUncheckedBorderColor: "var(--text)",
        checkboxUncheckedBackgroundColor: "transparent",
        columnBorder: true,
        fontFamily: {
            googleFont: "Roboto, Helvetica, Arial, sans-serif"
        },
        focusShadow: '0px 0px 2px 1.6px color-mix(in srgb, transparent, var(--hover-bg) 40%)',
        inputBackgroundColor: 'var(--bg)',
        inputFocusBorder:'solid 1px color-mix(in srgb, transparent, var(--border) 40%)',
        fontSize: '0.875rem',
        headerBackgroundColor: "var(--bg-lighter)",
        headerFontSize: 14,
        headerFontWeight: 600,
        headerTextColor: "var(--text)",
        menuTextColor: "var(--text)",
        rangeSelectionBorderColor: "var(--selected )",
        rowBorder: { style: 'solid', width: 1, color: 'var(--border)' },
        rowVerticalPaddingScale: 0.8,
        sidePanelBorder: true,
        spacing: 6,
        textColor: "var(--text)",
        wrapperBorder: true,
        wrapperBorderRadius: 5
    });
export const centerCellText = {
    cellClass: 'cellCenter', headerClass: 'cellCenter'
}
export const agTextColumnFilterProps = <T = any>(): ColDef<T> => {
    return { filter: "agTextColumnFilter", floatingFilter: true, suppressFloatingFilterButton: true, suppressHeaderFilterButton: true }
}
export const agDateColumnFilterProps = <T = any> (): ColDef<T> => {
    return { filter: "agDateColumnFilter", floatingFilter: true, suppressFloatingFilterButton: true, suppressHeaderFilterButton: true }
}
export const agNumberColumnFilterProps = <T = any>(): ColDef<T> => {
    return { filter: "agNumberColumnFilter", floatingFilter: true, suppressFloatingFilterButton: true, suppressHeaderFilterButton: true }
}
//export const DateFilter = {
//    filter: 'agDateColumnFilter', // для поддержки фильтрации по дате
//    floatingFilter: true,
//    floatingFilterComponent: CustomDateFilter,
//    suppressFloatingFilterButton: true,
//    suppressHeaderFilterButton: true,
//}
export const SelectFilter = {
    filter: 'agTextColumnFilter',
    floatingFilter: true,
    floatingFilterComponent: CustomSelectFilter,
    suppressFloatingFilterButton: true,
    suppressHeaderFilterButton: true,
}